export default __webpack_public_path__ + "static/media/Quickadd.2fd371f9.svg";